import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorVolatileMarket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M7.82 5.47a.75.75 0 0 0-1.06 0L2.97 9.26a.75.75 0 0 0 1.06 1.06L6.54 7.81v10.82a.75.75 0 0 0 1.5 0V7.812l2.509 2.509a.75.75 0 0 0 1.06-1.06L7.82 5.47Z"
    />
    <path
      fill="#F7A600"
      d="M17.46 6a.75.75 0 0 0-1.5 0v10.821l-2.509-2.51a.75.75 0 0 0-1.06 1.061l3.79 3.79a.75.75 0 0 0 1.06 0l3.79-3.79a.75.75 0 1 0-1.061-1.06l-2.51 2.508V6Z"
    />
  </svg>
);
export default SvgTwoColorVolatileMarket;
